import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck } from "lucide-react";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function Forgot() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api("/auth/forgot", { method: "POST", body: { email: email.trim().toLowerCase() }, auth: false });
      setSent(true);
    } catch (err) {
      toast.error(err.message || "Erreur");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell title={t("a.forgotTitle")} subtitle={t("a.forgotSub")}>
      {sent ? (
        <div className="text-center space-y-4 py-4" data-testid="forgot-sent">
          <div className="mx-auto h-14 w-14 grid place-items-center rounded-full bg-teal-100 text-teal-700">
            <MailCheck size={28} />
          </div>
          <p className="text-slate-600 text-sm">{t("a.forgotSent")}</p>
          <Link to="/auth/login"><Button variant="outline" className="rounded-xl">{t("a.back")}</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">{t("a.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={t("hc.youBusinessCom")} className="mt-1.5 h-11 rounded-xl" data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl font-semibold" data-testid="forgot-submit">
            {loading ? <span className="inline-flex items-center gap-1.5"><FindoSpinner size={16} />{t("a.sending")}</span> : t("a.sendLink")}
          </Button>
          <p className="text-center text-sm text-slate-500">
            <Link to="/auth/login" className="font-semibold text-findo-indigo hover:underline">{t("a.back")}</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
